/* eslint-disable react/forbid-prop-types,react/no-array-index-key */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './TimelineMilestoneSidebar.scss';

class TimelineMilestoneSidebar extends Component {

    static propTypes = {
        milestones: PropTypes.array,
        currentYear: PropTypes.number,
        goToYear: PropTypes.func.isRequired
    };

    static defaultProps = {
        milestones: [],
        currentYear: null
    };

    getClass = (milestone) => {
        const {currentYear} = this.props;

        let cssClass = 'timelineMilestoneSidebar__button';
        if (milestone.year === currentYear) {
            cssClass = `${cssClass} timelineMilestoneSidebar__button--active`;
        }

        return cssClass;
    };

    render() {
        const {currentYear, goToYear, milestones} = this.props;

        const years = [];
        const yearsInSidebar = [];

        milestones.filter(milestone => milestone.year).forEach((milestone, index) => {
            if (yearsInSidebar.includes(milestone.year)) return;
            yearsInSidebar.push(milestone.year);
            years.push({milestone, index});
        });

        return (
            <div className="timelineMilestoneSidebar">
                <ul>
                    {years.map(year => (
                    <li key={`timelineMilestoneSidebar__button__${year.milestone.year || 'intro'}--${year.index}`}
                        className="timelineMilestoneSidebar__item">
                        <button className={this.getClass(year.milestone)}
                                onClick={() => goToYear(year.milestone.year)}
                                data-active={year.milestone.year === currentYear}>
                            <span>{year.milestone.year}</span>
                        </button>
                    </li>
                ))}
                </ul>
            </div>
        );
    }
}

export default TimelineMilestoneSidebar;



// WEBPACK FOOTER //
// ./frontend/components/TimelineMilestone/TimelineMilestoneSidebar.jsx